import React from 'react';
import { useTranslation } from 'react-i18next';

const EULA = () => {
  const { t } = useTranslation();
  const LAST_UPDATE_DATE = "05.03.2026";

  return (
    
    <div className="bg-black text-white min-h-screen p-8 pt-20">
      <h1 className="text-3xl font-bold mb-6">{t('eula.title')}</h1>
      <p className="mb-6 whitespace-pre-wrap font-sans">
        {t('eula.last_updated', { date: LAST_UPDATE_DATE })}
      </p>
      <p className="whitespace-pre-wrap font-sans">
        {t('eula.intro')}
      </p>

      <p className="mt-6 whitespace-pre-wrap">
        {t('eula.license_agreement_links.text_before')}{' '}
        <a href="https://www.apple.com/legal/internet-services/itunes/us/terms.html" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
          {t('eula.license_agreement_links.apple_link')}
        </a>{' '}
        {t('eula.license_agreement_links.text_middle')}{' '}
        <a href="https://play.google.com/intl/en_US/about/play-terms/" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
          {t('eula.license_agreement_links.google_link')}
        </a>{' '}
        {t('eula.license_agreement_links.text_after')}
      </p>

      <p className="whitespace-pre-wrap mt-4">
        {t('eula.opening2')}
      </p>

      {/* TABLE OF CONTENTS */}
      <h2 className="text-2xl font-bold mt-8 mb-4">{t('eula.toc.title')}</h2>
      <ol className="list-decimal list-inside">
        {t('eula.toc.items', { returnObjects: true }).map((item, index) => (
          <li key={index} className="mt-2">
            <a href={`#section-${index + 1}`} className="text-blue-500 hover:underline">
              {item}
            </a>
          </li>
        ))}
      </ol>

      {/* 1. THE APPLICATION */}
      <h2 id="section-1" className="text-2xl font-bold mt-12 mb-4">
        {t('eula.sections.the_application.title')}
      </h2>
      <p className="mt-4">{t('eula.sections.the_application.p1')}</p>
      <p className="mt-4">{t('eula.sections.the_application.p2')}</p>
      <p className="mt-4">{t('eula.sections.the_application.p3')}</p>
      <p className="mt-4">{t('eula.sections.the_application.p4')}</p>
      <p className="mt-4">{t('eula.sections.the_application.p5')}</p>

      {/* 2. SCOPE OF LICENSE */}
      <h2 id="section-2" className="text-2xl font-bold mt-12 mb-4">
        {t('eula.sections.scope_of_license.title')}
      </h2>
      <p className="mt-4">{t('eula.sections.scope_of_license.p1')}</p>
      <p className="mt-4">{t('eula.sections.scope_of_license.p2')}</p>
      <p className="mt-4">{t('eula.sections.scope_of_license.p3')}</p>
      <p className="mt-4">{t('eula.sections.scope_of_license.p4')}</p>
      <p className="mt-4">{t('eula.sections.scope_of_license.p5')}</p>
      <p className="mt-4">{t('eula.sections.scope_of_license.p6')}</p>
      <p className="mt-4">{t('eula.sections.scope_of_license.p7')}</p>
      <p className="mt-4">{t('eula.sections.scope_of_license.p8')}</p>

      {/* 3. TECHNICAL REQUIREMENTS */}
      <h2 id="section-3" className="text-2xl font-bold mt-12 mb-4">
        {t('eula.sections.technical_requirements.title')}
      </h2>
      <p className="mt-4">{t('eula.sections.technical_requirements.p1')}</p>
      <p className="mt-4">{t('eula.sections.technical_requirements.p2')}</p>
      <p className="mt-4">{t('eula.sections.technical_requirements.p3')}</p>
      <p className="mt-4">{t('eula.sections.technical_requirements.p4')}</p>

      {/* 4. NO MAINTENANCE OR SUPPORT */}
      <h2 id="section-4" className="text-2xl font-bold mt-12 mb-4">
        {t('eula.sections.no_maintenance.title')}
      </h2>
      <p className="mt-4">{t('eula.sections.no_maintenance.p1')}</p>
      <p className="mt-4">{t('eula.sections.no_maintenance.p2')}</p>

      {/* 5. USE OF DATA */}
      <h2 id="section-5" className="text-2xl font-bold mt-12 mb-4">
        {t('eula.sections.use_of_data.title')}
      </h2>
      <p className="mt-4">
        {t('eula.sections.use_of_data.p1')}{' '}
        <a href="https://www.confesz.com/privacy_policy" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline inline">
          https://www.confesz.com/privacy_policy
        </a>.
      </p>
      <p className="mt-4">{t('eula.sections.use_of_data.p2')}</p>
      <p className="mt-4">
        {t('eula.sections.use_of_data.p3')}{' '}
        <a href="mailto:confesz@tech-center.com" className="text-blue-500 hover:underline inline">
          confesz@tech-center.com
        </a>{' '}
        {t('eula.use_of_data_links.p3_suffix')}
      </p>

      {/* 6. USER-GENERATED CONTRIBUTIONS */}
      <h2 id="section-6" className="text-2xl font-bold mt-12 mb-4">
        {t('eula.sections.user_contributions.title')}
      </h2>
      <p className="mt-4">{t('eula.sections.user_contributions.p1')}</p>
      <ol className="list-decimal list-outside pl-12 mt-4">
        {t('eula.sections.user_contributions.inner_list', { returnObjects: true }).map((item, index) => (
          <li key={index} className="mt-2">{item}</li>
        ))}
      </ol>
      <p className="mt-4">{t('eula.sections.user_contributions.p2')}</p>
      <p className="mt-4">
        {t('eula.sections.user_contributions.p3')}{' '}
        <a href="mailto:confesz@tech-center.com" className="text-blue-500 hover:underline inline">
          confesz@tech-center.com
        </a>.
      </p>

      {/* 7. CONTRIBUTION LICENSE */}
      <h2 id="section-7" className="text-2xl font-bold mt-12 mb-4">
        {t('eula.sections.contribution_license.title')}
      </h2>
      <p className="mt-4">{t('eula.sections.contribution_license.p1')}</p>
      <p className="mt-4">{t('eula.sections.contribution_license.p2')}</p>
      <p className="mt-4">{t('eula.sections.contribution_license.p3')}</p>
      <p className="mt-4">{t('eula.sections.contribution_license.p4')}</p>

      {/* 8. LIABILITY */}
      <h2 id="section-8" className="text-2xl font-bold mt-12 mb-4">
        {t('eula.sections.liability.title')}
      </h2>
      <p className="mt-4">{t('eula.sections.liability.p1')}</p>
      <p className="mt-4">{t('eula.sections.liability.p2')}</p>

      {/* 9. WARRANTY */}
      <h2 id="section-9" className="text-2xl font-bold mt-12 mb-4">
        {t('eula.sections.warranty.title')}
      </h2>
      <p className="mt-4">{t('eula.sections.warranty.p1')}</p>
      <p className="mt-4">{t('eula.sections.warranty.p2')}</p>
      <p className="mt-4">
        {t('eula.sections.warranty.p3')}{' '}
        <a href="https://confesz.com/contact" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline inline">
          {t('eula.sections.warranty.p3_link')}
        </a>
        {t('eula.sections.warranty.p3_suffix')}
      </p>
      <p className="mt-4">{t('eula.sections.warranty.p4')}</p>
      <p className="mt-4">{t('eula.sections.warranty.p5')}</p>
      <p className="mt-4">{t('eula.sections.warranty.p6')}</p>

      {/* 10. PRODUCT CLAIMS */}
      <h2 id="section-10" className="text-2xl font-bold mt-12 mb-4">
        {t('eula.sections.product_claims.title')}
      </h2>
      <p className="mt-4">{t('eula.sections.product_claims.p1')}</p>
      <p className="whitespace-pre-wrap pl-8 mt-4">{t('eula.sections.product_claims.i')}</p>
      <p className="whitespace-pre-wrap pl-8 mt-4">{t('eula.sections.product_claims.ii')}</p>
      <p className="whitespace-pre-wrap pl-8 mt-4">{t('eula.sections.product_claims.iii')}</p>

      {/* 11. LEGAL COMPLIANCE */}
      <h2 id="section-11" className="text-2xl font-bold mt-12 mb-4">
        {t('eula.sections.legal_compliance.title')}
      </h2>
      <p className="mt-4">{t('eula.sections.legal_compliance.p1')}</p>
      <p className="mt-4">{t('eula.sections.legal_compliance.p2')}</p>

      {/* 12. CONTACT INFORMATION */}
      <h2 id="section-12" className="text-2xl font-bold mt-12 mb-4">
        {t('eula.sections.contact_information.title')}
      </h2>
      <p className="mt-4">{t('eula.sections.contact_information.p1')}</p>
      <p className="mt-4">{t('eula.sections.contact_information.name')}</p>
      <p className="mt-0">{t('eula.sections.contact_information.city')}</p>
      <p className="mt-0">{t('eula.sections.contact_information.address')}</p>
      <p className="mt-0">{t('eula.sections.contact_information.country')}</p>
      <p className="mt-0">{t('eula.sections.contact_information.email')}</p>

      {/* 13. TERMINATION */}
      <h2 id="section-13" className="text-2xl font-bold mt-12 mb-4">
        {t('eula.sections.termination.title')}
      </h2>
      <p className="mt-4">{t('eula.sections.termination.p1')}</p>

      {/* 14. THIRD-PARTY TERMS */}
      <h2 id="section-14" className="text-2xl font-bold mt-12 mb-4">
        {t('eula.sections.third_party_terms.title')}
      </h2>
      <p className="mt-4">{t('eula.sections.third_party_terms.p1')}</p>
      <p className="mt-4">{t('eula.sections.third_party_terms.p2')}</p>

      {/* 15. INTELLECTUAL PROPERTY RIGHTS */}
      <h2 id="section-15" className="text-2xl font-bold mt-12 mb-4">
        {t('eula.sections.intellectual_property.title')}
      </h2>
      <p className="mt-4">{t('eula.sections.intellectual_property.p1')}</p>

      {/* 16. APPLICABLE LAW */}
      <h2 id="section-16" className="text-2xl font-bold mt-12 mb-4">
        {t('eula.sections.applicable_law.title')}
      </h2>
      <p className="mt-4">{t('eula.sections.applicable_law.p1')}</p>

      {/* 17. MISCELLANEOUS */}
      <h2 id="section-17" className="text-2xl font-bold mt-12 mb-4">
        {t('eula.sections.miscellaneous.title')}
      </h2>
      <p className="mt-4">{t('eula.sections.miscellaneous.p1')}</p>
      <p className="mt-4">{t('eula.sections.miscellaneous.p2')}</p>
    </div>
  );
};

export default EULA;